import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import HomeHero from "@/components/sections/HomeHero";
import { WhoWeAre, WhyChoose, FeaturedPortfolio, FeaturedFilms, Process, TestimonialsCarousel, GoogleReviews, AvailabilityForm, Packages, FaqSection, CtaStrip } from "@/components/sections/HomeSections";
import { SnapPicSection, StorySongSection } from "@/components/sections/FeaturedExperienceSections";
import GlobalLoveStories from "@/components/sections/GlobalLoveStories";
import SEO, { localBusinessSchema } from "@/components/SEO";

export default function Home({ settings }) {
  const [hp, setHp] = useState(null);
  useEffect(() => { api.get("/homepage").then(r => setHp(r.data)).catch(() => setHp({})); }, []);

  const seoTitle = hp?.seo?.title || "";
  const seoDesc = hp?.seo?.description ||
    "Wedding photography and films created to preserve the moments and emotions you never want to forget — across Canada, the United States, and wherever your love story takes you.";

  return (
    <div data-testid="home-page">
      <SEO title={seoTitle} description={seoDesc} path="/" image={hp?.seo?.og_image} jsonLd={localBusinessSchema()} />
      <HomeHero hero={hp?.hero} slides={hp?.hero_slides || []} />
      <WhoWeAre content={hp?.who_we_are} />
      <WhyChoose content={hp?.why_choose_us} />
      <FeaturedPortfolio content={hp?.featured_portfolio} />
      <FeaturedFilms content={hp?.featured_films} />
      <Process content={hp?.process} />
      <SnapPicSection data={hp?.snappic_section} />
      <StorySongSection data={hp?.story_song_section} />
      <TestimonialsCarousel content={hp?.testimonials_section} />
      <GoogleReviews content={hp?.google_reviews_section} />
      <GlobalLoveStories />
      <AvailabilityForm content={hp?.availability_section} />
      <Packages content={hp?.packages_section} />
      <FaqSection limit={8} content={hp?.faq_section} />
      <CtaStrip content={hp?.cta_strip} />
    </div>
  );
}
